import styled, {keyframes} from "styled-components";
import { useState } from "react";
import { login } from "../api/auth";
import { useNavigate } from "react-router-dom";
import { BtnHoverAnimation } from "../animes";
import Copyright from "../public/Copyright";

/* Login.tsx는 로그인 폼을 보여주는 컴포넌트 */

export const isLoggedIn = () => {
    return !!localStorage.getItem("accessToken");
};

export const LogOut = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    alert("로그아웃 되었습니다.")
    window.location.href = "/";
};

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Body = styled.div`
    width: 100vw;
    height: 100vh;
    background: linear-gradient(135deg, ${props => props.theme.ROOT_BACKGROUND.FIRST} 0%, ${props => props.theme.ROOT_BACKGROUND.LAST} 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-family: 'Pretendard', -apple-system, sans-serif;
    overflow: hidden;
`;

const Box = styled.div`
    width: 20rem;
    height: 30rem;
    padding: 3rem 2rem;
    background: ${props => props.theme.BOX_BACKGROUND};
    backdrop-filter: blur(10px);
    border-radius: 1.5rem;
    border: 1px solid ${props => props.theme.BOX_BORDER};
    box-shadow: 0 20px 25px -5px ${props => props.theme.BOX_SHADOW.FIRST}, 0 10px 10px -5px ${props => props.theme.BOX_SHADOW.LAST};
    animation: ${fadeIn} 0.8s ease-out;
`;

const Title = styled.h1`
  font-size: 1.8rem;
  font-weight: 800;
  color: ${props => props.theme.HEADER.BLOG_NAME};
  text-align: center;
  margin-bottom: 1rem;
  letter-spacing: -0.05rem;
`;

const Icon = styled.div`
    display: flex;
    flex-direction: column;
    margin: 2rem auto;

    width: 8rem;
    height: 8rem;
    
    background-color: linear-gradient(135deg, #f8fafccb 0%, #cbd5e1b4 100%);
`;

const Head = styled.div`
    display: flex;
    margin:auto;

    width: 4em;
    height: 4em;
    background: linear-gradient(135deg, #bfc2c7 0%, #bfc2c732 100%);
    border-radius: 2em;
`;

const Upper = styled.div`
    display: flex;
    margin:auto;

    width: 6em;
    height: 3em;
    
    background: linear-gradient(135deg, #bfc2c7 0%, #bfc2c732 100%);
    border-top-left-radius: 3rem;
    border-top-right-radius: 3rem;
    border-bottom-left-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;

    top: 5em;
`;

const Form = styled.form`
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const SubTitle = styled.div`
    letter-spacing: -0.05rem;
    color: ${props => props.theme.MENU.SUBTITLE_COLOR};
`;

const Username = styled.div`
    margin-bottom: 1rem;
`;

const Password = styled.div`
    margin-bottom: 1rem;
`;

const Enter = styled.input`
    width: 20em;
    height: 2em;
    padding: 2px 10px;
    border-radius: 2rem;
    margin-top: 0.5rem;

    border: 1px solid ${props => props.theme.SEARCH.BORDER};
    background: ${props => props.theme.SEARCH.BACKGROUND};
    box-shadow: inset 0 2px 4px ${props => props.theme.SEARCH.SHADOW};
    color: ${props => props.theme.CONTENT.TITLE_COLOR};

    &:focus {
        outline: none;
        border-color: ${props => props.theme.SEARCH.FOCUS.BORDER};
        box-shadow: inset 0 2px 4px ${props => props.theme.SEARCH.FOCUS.SHADOW};
    }
`;

const Btn = styled.button`
    margin-top: 2rem;
    width: 5rem;
    height: 2.5rem;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 1rem;
    transition: all 1s ease;
    color: white;
    
    letter-spacing: -1px;
    font-weight: 600;
    
    &:hover {
        animation: ${props => BtnHoverAnimation(props.theme.BTN_ENTER.HOVER.BACKGROUND.FIRST, props.theme.BTN_ENTER.HOVER.BACKGROUND.LAST)} 0.3s;
        background-color: ${props => props.theme.BTN_ENTER.HOVER.BACKGROUND.LAST};
        box-shadow: inset 0 6px 6px ${props => props.theme.BTN_ENTER.HOVER.SHADOW};
    }
    
    &:not(:hover) {
        animation: ${props => BtnHoverAnimation(props.theme.BTN_ENTER.HOVER.BACKGROUND.LAST, props.theme.BTN_ENTER.HOVER.BACKGROUND.FIRST)} 0.3s;
        background-color: ${props => props.theme.BTN_ENTER.HOVER.BACKGROUND.FIRST};
    }
`;

function Login() {
    const navigate  = useNavigate();

    const [username, setUsername] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const onChangeUserName = (e:React.ChangeEvent<HTMLInputElement>) => {
        setUsername(e.target.value);
    };

    const onChangePassword = (e:React.ChangeEvent<HTMLInputElement>) => {
        setPassword(e.target.value);
    };

    const handleLogin = async () => {
        try {
            const data = await login(username, password);

            localStorage.setItem('accessToken', data.accessToken);
            localStorage.setItem('refreshToken', data.refreshToken);

            navigate("/");

        } catch (error){
            alert("Login failed");
        }
    };

    const activeEnter = (e:React.KeyboardEvent) => {
        if (e.code !== "Enter") return;
        handleLogin();
    }

    return (
    <Body>
        <Box>
            <Title>Log In</Title>
            <Icon>
                <Head/>
                <Upper/>
            </Icon>
            <Form>
                <Username>
                    <SubTitle>Your Username</SubTitle>
                    <Enter type="text" onChange={onChangeUserName} />
                </Username>
                <Password>
                    <SubTitle>Password</SubTitle>
                    <Enter type="password" onChange={onChangePassword} onKeyDown={activeEnter}/>
                </Password>
                <Btn type="button" 
                    onClick={handleLogin}>Log In</Btn>
            </Form>
        </Box>
	<Copyright />
    </Body>);
}

export default Login;
